import { useInfiniteQuery } from '@tanstack/react-query';

import {
  RecognitionPage,
  RecognitionStatus,
  recognitionService,
  useToast,
} from '@aslanpay/portal-common-lib';

const useInfiniteFetchRecognitionsByGroup = (
  groupId: string,
  size: number,
  enabled = true,
  statuses?: RecognitionStatus[]
) => {
  const toast = useToast();

  return useInfiniteQuery<RecognitionPage, Error>({
    queryKey: ['fetchRecognitionsByGroup', groupId, size, statuses],
    queryFn: ({ pageParam = 0 }) =>
      recognitionService.fetchRecognitions({
        groupIds: [groupId],
        page: pageParam,
        size,
        statuses,
      }),
    getNextPageParam: (lastPage) => {
      const hasMore = (lastPage.pageNumber + 1) * lastPage.pageSize < lastPage.total;
      return hasMore ? lastPage.pageNumber + 1 : undefined;
    },
    enabled,
    onError: () => {
      toast({
        position: 'top-right',
        status: 'error',
        title: 'Something went wrong',
        description: 'Sorry, we failed to fetch the recognitions. Please try again.',
      });
    },
  });
};

export default useInfiniteFetchRecognitionsByGroup;
